




































































import { Component, Vue } from "vue-property-decorator";
import HomeCarouselFrame from "../home/HomeCarouselFrame.vue";
import IconTestimonialRing from "../icons/IconTestimonialRing.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import { TextBlockType } from "../../core/constants";
import store from "../../core/store";

interface TestimonialEntry {
  image?: string;
  title?: string;
  smalText?: string;
  text?: string;
}

@Component({
  components: { HomeCarouselFrame, IconTestimonialRing, VueSlickCarousel },
})
export default class Testimonial extends Vue {
  data: TestimonialEntry[] = [];
  activeIndex = 0;
  virtualIndex = 0;
  pendingIndex: number | null = null;

  async mounted() {
    let filter: any = {};
    filter["TextBlockType"] = {
      type: "equals",
      filter: TextBlockType.Testimonials,
      filterType: "enum",
    };
    const gridStatus = JSON.stringify({ filters: filter });

    const url = `${
      Settings.HostName
    }/api/cztextblocks/list?startRow=0&endRow=14&lookup=true&gridstatus=${encodeURIComponent(
      gridStatus
    )}`;

    const data = await new CrudService().httpGet(url);
    if (data == null) {
      console.error("Crash getting testimonials");
      return;
    }
    this.data = data.rowData;
    this.activeIndex = 0;
    this.virtualIndex = 0;
    this.pendingIndex = null;
    this.$emit("loaded", this.data.length);
  }

  get activeSlide() {
    return this.getSlideAt(this.activeIndex, 0);
  }

  get shouldAutoplay() {
    return this.data.length > 1;
  }

  get showSideCircles() {
    return this.data.length > 2;
  }

  get showSmallCircles() {
    return this.data.length > 4;
  }

  get isDouble() {
    return this.data.length === 2;
  }

  get visibleOffsets() {
    const total = this.data.length;
    if (total <= 1) return [0];
    if (total === 2) return [0, 1];
    const offsets = [0];
    if (this.showSideCircles) {
      offsets.unshift(-1);
      offsets.push(1);
    }
    if (this.showSmallCircles) {
      offsets.unshift(-2);
      offsets.push(2);
    }
    return offsets;
  }

  get visibleSlides() {
    const total = this.data.length;
    if (total === 0) return [];
    return this.visibleOffsets.map((offset) => {
      const index = (this.activeIndex + offset + total) % total;
      const slide = this.data[index] || this.data[0];
      const ariaLabel = slide.title
        ? slide.title
        : String(this.$t("Testimonials"));
      return {
        offset,
        index,
        slide,
        key: String(this.virtualIndex + offset),
        ariaLabel,
      };
    });
  }

  getSlideAt(index: number, offset: number) {
    const total = this.data.length;
    if (total === 0) {
      return {
        image: "",
        title: "",
        smalText: "",
        text: "",
      };
    }
    const nextIndex = (index + offset + total) % total;
    return this.data[nextIndex] || this.data[0];
  }

  get carouselSettings() {
    const shouldLoop = this.data.length > 1;
    const shouldAutoplay = this.shouldAutoplay;
    return {
      arrows: false,
      dots: false,
      infinite: shouldLoop,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: shouldAutoplay,
      speed: 0,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
    };
  }

  onAfterChange(current: any) {
    const total = this.data.length;
    if (total === 0) return;
    if (typeof current === "number") {
      if (this.pendingIndex !== null && current === this.pendingIndex) {
        this.pendingIndex = null;
        return;
      }
      if (this.pendingIndex !== null) {
        this.pendingIndex = null;
      }
      const previousIndex = this.activeIndex;
      this.activeIndex = current;
      this.virtualIndex += this.getNormalizedDelta(
        current,
        previousIndex,
        total
      );
      return;
    }
    if (current && typeof current.currentSlide === "number") {
      if (
        this.pendingIndex !== null &&
        current.currentSlide === this.pendingIndex
      ) {
        this.pendingIndex = null;
        return;
      }
      if (this.pendingIndex !== null) {
        this.pendingIndex = null;
      }
      const previousIndex = this.activeIndex;
      this.activeIndex = current.currentSlide;
      this.virtualIndex += this.getNormalizedDelta(
        current.currentSlide,
        previousIndex,
        total
      );
    }
  }

  setActiveIndex(index: number) {
    if (this.data.length === 0) return;
    const total = this.data.length;
    const previousIndex = this.activeIndex;
    const nextIndex = ((index % total) + total) % total;
    this.activeIndex = nextIndex;
    this.virtualIndex += this.getNormalizedDelta(
      nextIndex,
      previousIndex,
      total
    );
    this.pendingIndex = nextIndex;
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.goTo) {
      carousel.goTo(nextIndex);
    }
    this.restartAutoplay();
  }

  setActiveOffset(offset: number) {
    if (this.data.length === 0) return;
    const total = this.data.length;
    const nextIndex = (this.activeIndex + offset + total) % total;
    this.setActiveIndex(nextIndex);
  }

  getNormalizedDelta(nextIndex: number, currentIndex: number, total: number) {
    if (total <= 0) return 0;
    const raw = nextIndex - currentIndex;
    const forward = (raw + total) % total;
    const backward = forward - total;
    return Math.abs(backward) < Math.abs(forward) ? backward : forward;
  }

  circleClass(offset: number) {
    if (offset === 0) return "testimonialsCarousel__circle--center";
    if (offset === -1) return "testimonialsCarousel__circle--left";
    if (offset === 1) return "testimonialsCarousel__circle--right";
    if (offset === -2) return "testimonialsCarousel__circle--leftSm";
    if (offset === 2) return "testimonialsCarousel__circle--rightSm";
    return "testimonialsCarousel__circle--center";
  }

  onCircleClick(offset: number) {
    if (offset === 0) return;
    this.setActiveOffset(offset);
  }

  nextSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevSlide() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }

  getPlainText(html: string) {
    if (html === undefined || html === null || html === "") return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").trim();
  }

  hasContent(html: string) {
    return this.getPlainText(html).length > 0;
  }

  getImagePath(img: string) {
    if (img === undefined || img === null || img === "") {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }
}
